<script lang="ts">
    import { get_current_component, onMount } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faCaretDown, faCaretUp, faEdit, faCheckDouble, faPrint, faUser } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import { InvoicesRepository } from '../../modules/posApi/invoices/invoices.repository'
    import { InvoicesService } from '../../modules/posApi/invoices/invoices.service'
    import type { Invoice } from '../../modules/posApi/invoices/invoice'
    import type { Service } from '../../modules/posApi/services/service'
    import { ServicesRepository } from '../../modules/posApi/services/services.repository'
    import { ServicesService } from '../../modules/posApi/services/services.service'
    import { UsersRepository } from '../../modules/usersApi/users/users.repository'
    import { UsersService } from '../../modules/usersApi/users/users.service'
    import type { User } from '../../modules/usersApi/users/user'
    import type { PaymentMethod } from '../../modules/posApi/payment-methods/payment-methods'
    import { PaymentMethodsRepository } from '../../modules/posApi/payment-methods/payment-methods.repository'
    import { PaymentMethodsService } from '../../modules/posApi/payment-methods/payment-methods.service'
    import Popover from '../_common/popover.svelte'
    import PosEntriesStatus from '../pos/pos-entries-status.svelte'
    import PosForm from '../pos/pos-form.svelte'
    import {
        GridBadge,
        GridBadgeClassEnum,
        GridButton,
        GridClass,
        GridCol,
        GridColAlignEnum,
        GridColTypeEnum,
        GridItemShow,
        GridLine,
    } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'
    import type { QuotationEntity } from '../../modules/posApi/quotation/quotation.entity'
    import QuotationForm from '../pos/quotation/quotation-form.svelte'
    // ##############################################################################################################

    export let personId: string

    const entityId = 'personId'

    const rep = new InvoicesRepository()
    const service = new InvoicesService(rep)

    let pmR = new PaymentMethodsRepository()
    let pmS = new PaymentMethodsService(pmR)

    let servicesR = new ServicesRepository()
    let servicesS = new ServicesService(servicesR)

    let users: User[] = []

    const me = get_current_component()
    let show = false
    let invoices: Invoice[] = []

    let noPaid: number = 0
    async function loadEntities() {
        try {
            show = true
            noPaid = 0
            selectedIndex = -1
            const promises = [
                service.getAll({ personId }, 600),
                servicesS.getAll({ excluded: true, type: 'all' }, 600),
                pmS.getAll({ excluded: true }, 600),
                window.api.users.companies.getCompanyUsers(600),
            ]
            let services: Service[]
            let payments: PaymentMethod[]
            ;[invoices, services, payments, users] = await Promise.all(promises)
            for (let invoice of invoices) {
                for (let payment of invoice.payments) {
                    payment.paymentMethod = payments.find((el) => el.paymentMethodId === payment.paymentMethodId)
                }
                for (let service of invoice.services) {
                    service.service = services.find((el) => el.serviceId === service.serviceId)
                    service.user = users.find((el) => el.userId === service.userId)
                }
            }
            await loadNoPaidInvoices(personId)
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function loadNoPaidInvoices(personId) {
        noPaid = 0
        noPaid = await window.api.pos.invoices.getCreditAndDebitsFromPerson(personId)
        console.log('nopaid', noPaid)
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(async () => {
        await loadEntities()
        await loadQuotes()
    })

    function translateStatus(status) {
        if (status === 'open') return 'Aberto'
        if (status === 'closed') return 'Fechado'
        if (status === 'subsidized') return 'Baixado'
        if (status === 'credit') return 'Crédito'
        if (status === 'budget') return 'Orçamento'
        return 'Parcial'
    }

    let selectedIndex = -1

    function statusCanceled() {
        statusInvoiceId = null
    }

    let statusInvoiceId = null
    function changeStatus(invoiceId) {
        statusInvoiceId = invoiceId
    }

    function onStatusChanged() {
        loadEntities()
        statusInvoiceId = null
    }

    let showForm = false
    let invoiceId: string = null
    function editEntity(id) {
        invoiceId = id
        showForm = true
    }

    async function formChanged(event) {
        if (quotation?.quotationId && event.detail.invoiceId) {
            await window.api.pos.quotations.setPaid(quotation.quotationId, {
                invoiceId: event.detail.invoiceId,
            })
        }
        await loadQuotes()
        await loadEntities()
        invoiceId = null
        showForm = false
        quotation = null
        showQuotationForm = false
    }
    function formCanceled() {
        invoiceId = null
        showForm = false
        quotation = null
        showQuotationForm = false
    }

    let quotes: QuotationEntity[] = []
    async function loadQuotes() {
        try {
            show = true
            quotes = await window.api.pos.quotations.getAll({ personId, service: true }, 600)
            loadGridQuotes()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    let grid = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.showActs = true
        grid.title = 'Vendas Realizadas'
        grid.subtitle = ''
        gridQuotes.fontSize = '15px'
        grid.cols.push(
            new GridCol({
                content: 'Status',
                type: GridColTypeEnum.button,
                align: GridColAlignEnum.left,
            }),
        )
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Itens', type: GridColTypeEnum.float_2, showTotal: true, showTotalBox: false }))
        grid.cols.push(
            new GridCol({
                content: 'Total pago',
                type: GridColTypeEnum.float_2,
                showTotal: true,
                showTotalBox: false,
            }),
        )
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of invoices) {
            let line: GridLine = new GridLine()
            line.slots.push({
                content: [
                    new GridButton({
                        class: 'btn badge status_' + item.status,
                        icon: faCheckDouble,
                        label: translateStatus(item.status),
                        callback: () => {
                            changeStatus(item.invoiceId)
                        },
                    }),
                ],
            })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.total })
            line.slots.push({ content: item.totalPaid })
            line.slots.push({
                content: [
                    new GridButton({
                        icon: faEdit,
                        label: 'Editar',
                        callback: () => {
                            editEntity(item.invoiceId)
                        },
                    }),
                ],
            })
            grid.lines.push(line)
        }
        grid = grid
    }

    let gridQuotes: GridClass = new GridClass()
    function loadGridQuotes() {
        // grid
        gridQuotes = new GridClass()
        // grid head
        gridQuotes.title = 'Orçamentos Emitidos'
        gridQuotes.subtitle = ''
        gridQuotes.fontSize = '15px'
        gridQuotes.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        gridQuotes.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        gridQuotes.cols.push(new GridCol({ content: 'Vencimento', type: GridColTypeEnum.date }))
        gridQuotes.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2 }))
        gridQuotes.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of quotes) {
            const btnOpen = new GridButton({
                callback: () => editQuotationEntity(item.quotationId),
                icon: faEdit,
                label: 'Abrir',
            })
            //
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.createdAt })
            line.slots.push({
                content: new GridBadge({
                    label: getBadgeLabel(item),
                    class: getBadgeColor(item),
                }),
            })
            const expiresAt = new Date(item.createdAt)
            expiresAt.setDate(expiresAt.getDate() + item.expiresAt)
            line.slots.push({ content: expiresAt })
            line.slots.push({ content: item.items?.reduce((acc, el) => (acc += el.value * el.quantity), 0) })
            line.slots.push({ content: [btnOpen] })
            gridQuotes.lines.push(line)
        }
    }

    function getBadgeLabel(quotation: QuotationEntity) {
        if (quotation.status === 110) return 'faturado'
        if (quotation.expiresAt) {
            const expiresAt = new Date(quotation.createdAt)
            expiresAt.setDate(expiresAt.getDate() + quotation.expiresAt)
            const diffDays = dayjs(expiresAt).diff(quotation.createdAt, 'day')
            if (diffDays < 0) {
                return 'vencido'
            }
        }
        return 'ativo'
    }

    function getBadgeColor(quotation: QuotationEntity) {
        if (quotation.status === 110) return GridBadgeClassEnum.badge_purple // vendeu
        if (quotation.expiresAt) {
            const expiresAt = new Date(quotation.createdAt)
            expiresAt.setDate(expiresAt.getDate() + quotation.expiresAt)
            const diffDays = dayjs(expiresAt).diff(quotation.createdAt, 'day')
            if (diffDays < 0) {
                return GridBadgeClassEnum.badge_alert
            }
        }
        return GridBadgeClassEnum.badge_success
    }

    let showQuotationForm = false
    let quotationId: string = null
    function editQuotationEntity(id: string) {
        quotationId = id
        showQuotationForm = true
    }

    let quotation: QuotationEntity = null
    async function onQuotation(event) {
        if (event.detail.act === 'add') {
            invoiceId = null
            quotation = event.detail.quotation
        } else if (event.detail.act === 'edit') {
            invoiceId = event.detail.quotation.invoiceId
            quotation = null
        } else if (event.detail.act === 'open') {
            await window.api.pos.quotations.setUnpaid(event.detail.quotation.quotationId)
            await loadQuotes()
        } else if (event.detail.act === 'closed') {
            await window.api.pos.quotations.setPaid(event.detail.quotation.quotationId, {
                invoiceId: '*',
            })
            await loadQuotes()
        }
        quotationId = null
        showQuotationForm = false
    }
</script>

{#if statusInvoiceId}
    <Popover title="Alterar status do recebimento" width="620px" height="155px" on:close={statusCanceled}>
        <PosEntriesStatus invoiceId={statusInvoiceId} on:change={onStatusChanged} on:cancel={statusCanceled} />
    </Popover>
{/if}

{#if showQuotationForm}
    <Popover
        title="Orçamento"
        width="1300px"
        height="90vh"
        on:close={() => {
            showQuotationForm = false
        }}
    >
        <QuotationForm {quotationId} on:change={formChanged} on:cancel={formCanceled} on:invoice={onQuotation} />
    </Popover>
{/if}

{#if showForm || invoiceId || quotation}
    <Popover
        title="Venda"
        width="1300px"
        height="90vh"
        on:close={() => {
            showForm = false
            quotation = null
            invoiceId = null
        }}
    >
        <PosForm {quotation} {invoiceId} on:change={formChanged} on:cancel={formCanceled} />
    </Popover>
{/if}

{#if !show}
    {#if noPaid > 0.1}
        <div class="row border-bottom-0 px-1 mb-2">
            <div class="col" />
            <div class="col-md-5">
                <div class="input-group">
                    <label for="" class="input-group-text color_yellow">Valores em aberto:</label>
                    <input type="text" disabled={true} value={noPaid.toFixed(2)} class="form-control text-end" />
                </div>
            </div>
        </div>
    {/if}
    {#if noPaid < -0.1}
        <div class="row border-bottom-0 px-1 mb-2">
            <div class="col" />
            <div class="col-md-5">
                <div class="input-group">
                    <label for="" class="input-group-text color_green">Cliente com saldo:</label>
                    <input type="text" disabled={true} value={(-noPaid).toFixed(2)} class="form-control text-end" />
                </div>
            </div>
        </div>
    {/if}
    <Zgrid class="" {grid}></Zgrid>
    <Zgrid class="mt-3" grid={gridQuotes}></Zgrid>
{/if}

<style>
</style>
